<template>
<div>
  <div class="affa" v-if="$mq!='mobile'"> 
    <div class="affa__container-wrap" :style="`backgroundImage: url(${schema.settings.rowBgImage})`">
      <div class="affa__container" ref="container">
        <div
          class="affa__image affa__image--desktop third"
          >
          <div class="affa__image-primary" :style="imageShiftStyles">
            <image-ratio
              :src="schema.settings.imageDesktop"
              :alt="schema.settings.imageDesktopAlt"
              ratio="4:5"/>
          </div>
          <div class="affa__image-secondary" v-if="schema.settings.secondaryImage">
            <image-ratio :src="schema.settings.secondaryImage" :alt="schema.settings.secondaryImageAlt" ratio="3:5" inverse />
          </div>
        </div>
        <div class="affa__main-wrap first">
          <div class="" v-if="schema.settings.imageLeftTop" style="width:250px;">
            <image-ratio :src="schema.settings.imageLeftTop" :alt="schema.settings.imageLeftTopAlt" ratio="1:1" />
          </div>
          <div class="" v-if="schema.settings.tertiaryImage" style="width:200px;align-self: flex-end;">
            <image-ratio :src="schema.settings.tertiaryImage" :alt="schema.settings.imageLeftTop" ratio="1:1" />
          </div>
        </div>
        <div class="affa__main-wrap secound">
          <p
            class="preheader affa__preheader"
            v-if="schema.settings.preheader"
          >{{ schema.settings.preheader }}</p>
          <h5
            class="affa__header"  v-html="schema.settings.header"
            v-if="schema.settings.header"
          ></h5>
          
           <div class="affa__body_wrap">
      <div class="affa__body body-md client-generated"
            v-html="schema.settings.body"
            v-if="schema.settings.body"
      ></div>
    </div>

          <div class="affa__cta-container">
            <component
              :is="
                /link/.test(schema.settings.ctaStyle) ? 'v-link' : 'link-button'
              "
              tag="a"
              :class="schema.settings.ctaStyle"
              :href="schema.settings.ctaUrl"
              v-if="schema.settings.ctaText"
              :label="schema.settings.ctaText"
            >{{ schema.settings.ctaText }}</component>
          </div>
           
        </div>
      </div>
    </div>
   
  </div>
  <div class="affa" v-if="$mq=='mobile'"> 
    <div class="affa__container-wrap" :style="`backgroundImage: url(${schema.settings.rowBgImage})`">
      <div class="affa__container" ref="container">
        
        <div class="affa__main-wrap first" style="flex-direction:row">
          <div class="" v-if="schema.settings.imageLeftTop" style="width:250px;">
            <image-ratio :src="schema.settings.imageLeftTop" :alt="schema.settings.imageLeftTopAlt" ratio="1:1" />
          </div>
          <div class="" v-if="schema.settings.tertiaryImage" style="width:200px;align-self: flex-end;margin-top: 25%;">
            <image-ratio :src="schema.settings.tertiaryImage" :alt="schema.settings.imageLeftTop" ratio="1:1" />
          </div>
        </div>

        <div class="affa__main-wrap secound">
          <p
            class="preheader affa__preheader"
            v-if="schema.settings.preheader"
          >{{ schema.settings.preheader }}</p>
          <h5
            class="affa__header"  v-html="schema.settings.header"
            v-if="schema.settings.header"
          ></h5>
          
           <div class="affa__body_wrap">
                <div class="affa__body body-md client-generated"
                      v-html="schema.settings.body"
                      v-if="schema.settings.body"
                ></div>
             </div>

          <div class="affa__cta-container">
            <component
              :is="
                /link/.test(schema.settings.ctaStyle) ? 'v-link' : 'link-button'
              "
              tag="a"
              :class="schema.settings.ctaStyle"
              :href="schema.settings.ctaUrl"
              v-if="schema.settings.ctaText"
              :label="schema.settings.ctaText"
            >{{ schema.settings.ctaText }}</component>
          </div>
           
        </div>
        <div class="affa__main-wrap mobile-main-wrap">
          <div class="first_image" v-if="schema.settings.secondaryImage">
            <image-ratio :src="schema.settings.secondaryImage" :alt="schema.settings.secondaryImageAlt" ratio="3:5" inverse  />
          </div>
          <div class="second_image" v-if="schema.settings.imageDesktop" >
            <image-ratio :src="schema.settings.imageDesktop" :alt="schema.settings.imageDesktopAlt" ratio="3:5"/>
          </div>
        </div>

        <!-- <div
          class="affa__image affa__image--desktop third"
          >
          <div class="affa__image-primary" :style="imageShiftStyles">
            <image-ratio
              :src="schema.settings.imageDesktop"
              :alt="schema.settings.imageDesktopAlt"
              ratio="4:5"/>
          </div>
          <div class="affa__image-secondary" v-if="schema.settings.secondaryImage">
            <image-ratio :src="schema.settings.secondaryImage" :alt="schema.settings.secondaryImageAlt" ratio="3:5" inverse />
          </div>
        </div>   -->

        
        
      </div>
    </div>
   
  </div>
  </div>
</template>

<script>
import VButton from '../buttons/VButton.vue';
import VLink from '../buttons/VLink.vue';
import LinkButton from '../buttons/LinkButton.vue';
import SplitWrapper from '../basic/SplitWrapper.vue';
import ImageRatio from '@/scripts/components/basic/ImageRatio.vue'
import throttle from '@/scripts/helpers/optimizedEventThrottle.js';


export default {
  name: 'SpecialFiftyFiftyAlt',
  props: {
    schema: Object,
  },
  data() {
    return {
      scrollTop: 0,
      windowHeight: 0,
      offsetTop: 0,
      containerHeight: 0,
      containerObserver: null,
    }
  },
  computed: {
    imageShiftStyles() {
      return {};
      let scrollPosition = this.offsetTop - (this.scrollTop + this.windowHeight);
      let scrollProgression = Math.round(scrollPosition / this.containerHeight * 100);
      let translateY = 200;

      if (scrollProgression * -1 > 0 ) {
        translateY = 200 - (200 * (scrollProgression * -1 / 100));
      }
      return {
        transform: `translateY(${translateY}px)`,
      }
    }
  },
  components: {
    VButton,
    VLink,
    SplitWrapper,
    ImageRatio,
    LinkButton,
  },
  mounted() {
    window.bvaccel = window.bvaccel || {}
    if (!window.bvaccel.optimizedEvents) {
      window.bvaccel.optimizedEvents = true;
      throttle('scroll', 'optimizedScroll');
      throttle('resize', 'optimizedResize');
    }
    this.scrollTop = window.pageYOffset;
    this.windowHeight = window.innerHeight;
    this.offsetTop = this.$refs.container.offsetTop;
    this.containerHeight = this.$refs.container.offsetHeight;

    window.addEventListener('optimizedScroll', () => {
      this.scrollTop = window.pageYOffset;
    });
    window.addEventListener('optimizedResize', () => {
      this.windowHeight = window.innerHeight;
      this.offsetTop = this.$refs.container.offsetTop;
    });

    this.containerObserver = new ResizeObserver(entries => {
      this.offsetTop = this.$refs.container.offsetTop;
    });

    this.containerObserver.observe(this.$refs.container);
  }
};
</script>

<style lang="scss">
  .affa {
    &__container-wrap {
      margin-bottom: 20px;

      @include mobile_only {
        margin-bottom: 72px;
      }
    }

    &__container {
      width: 100%;
      max-width: 1440px;
      display: flex;
      flex-direction: column;
      position: relative;

      @include tablet-up {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        padding-bottom: 50px;
        margin: 0 auto;
      }
      @include hd-up {
        padding-bottom: 50px;
      }
    }
     
    &__body_wrap {
      max-width: 700px;
      margin: 0 auto;
      text-align: center;
      padding-bottom: 150px;

      @include mobile_only {
        padding-bottom: 0px;
      }
      
      .client-generated p {
        font-size: 18px;
        font-family: $font-family-primary;
        line-height: 30px;
        color: #171717;

        @include mobile_only {
          font-size: 15px;
          line-height: 25px;
          padding: 0 0px;
          text-align: center;
        }
      }

    }

    &__main-wrap {
      order: 1;
      padding: 150px 38px 68px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @include desktop-up {
        // xpadding-left: 150px;
        margin-bottom: 100px;
      }
      @include mobile-only {
        padding: 0px;
        margin-bottom: 34px;

      }

     
    }

    &__main-wrap > * {
      max-width: 430px;
      margin-bottom: 8px;
    }

    &__image {
      position: relative;


      @include tablet-up {
        order: 2;

        /* position: static; */
      }
    }

    &__image-primary {
      margin-top: 100px;
      max-width: calc(100% - 77px);

      @include tablet-up {
        max-width: 534px;
        margin-right: 77px;
      }
    }

    &__image-secondary {
      position: absolute;
      bottom: 0;
      width: 100%;
      transform: translateY(50%);
      max-width: 121px;
      left: -77px;

      @include tablet-up {
        top: 50%; 
        max-width: 150px;
        transform: none;
        left: -77px;
      }
      @include desktop-up {
        /* top: 50%; */
        bottom: 0;
        
        /* transform: translateY(75%); */
        right: 58px;
        max-width: 170px;
      }
      @include hd-up {
        max-width: 200px;
      }
    }

    &__image-tertiary {
      max-width: 168px;
      margin: 64px auto 0;
      width: 100%;

      @include tablet-up {
        position: absolute;
        bottom: -150px;
        margin-left: 0;
        margin-top: 126px;
        max-width: 311px !important;
      }
    }

    &__preheader {
      color: $color-terracotta-500;
      margin-bottom: 48px;
      @include mobile-only {
        margin-bottom: 17px;
      }
    }

    &__header {
      font-size: rem(28);
      line-height: rem(34);
      font-family: $font-family-primary;
      color: $color-green-slate-500;

      @include tablet-up {
        font-size: rem(32);
        line-height: rem(42);
        margin-bottom: 16px;
        font-family: $font-family-primary;
        color: $color-green-slate-500;
      }
    }

    &__body {
      margin-bottom: 32px;
    }

    &__body-margin-bottom--none {
      margin-bottom: 0;
    }


    .button {
      margin: 0;
    }

    &__cta-container {
      @include mobile-only {
        display: flex;
        flex-direction: column;
        align-items: center
      }
      
      .button {
        display: block;
        margin-bottom: 16px;

        @include tablet-up {
          display: inline-block;
          margin: 0;

          &:not(:last-child) {
            margin-right: 16px;
          }
        }
      }
    }

    .ratio-image {
      height: 0;
    }
    .first {
      gap: 43px;
    }
    .secound {
      text-align: center;
      @include mobile-only {
        padding-left: 10px;
        padding-right: 10px;
      }
    }
  }
  .mobile-main-wrap {
    flex-direction:row;
    justify-content:space-between;
    align-items: center;
    margin-bottom:0px;

  }
  .first_image {
      width:111px;
      margin-left: 40px;
    }
  .second_image {
      width:180px;
      align-self: flex-end;
    }
</style>